import angular from 'angular';
import _ from 'lodash';

import config from 'src/config';

partnerConfigs.$inject = [
  '$rootScope',
  'tl.query',
  'tl.storage',
  '$location',
  '$window',
  '$timeout',
  '$state',
  'jsSdk.booking',
  'jsSdk.keychain',
  'jsSdk.config',
  'iframeService',
  'urlService'
];

const CURRENT_YEAR = new Date().getFullYear();

export default function partnerConfigs($rootScope, query, storage, $location, $window, $timeout, $state, jsSdkBooking, jsSdkKeychain, jsSdkConfig, iframeService, urlService) {
  function createPartnerConfig(options) {
    const result = _.extend({}, defaultPartnerConfig, options);
    return result;
  }

  const defaultPartnerConfig = {
    hiderHeader: false,
    hideFooter: false,
    logoLink: '/',
    logo: 'https://assets.tablelist.com/www-2/tablelist/tablelist_logo_white_new_v2.png',
    configure() {
      const $body = angular.element('body');
      $body.addClass(`partner-${this.slug}`);

      if (!this.attributionId) this.attributionId = query.get('attributionId');
      if (!this.attributionType) this.attributionType = query.get('attributionType');
    },
    createBooking(bookingData) {
      if (this.attributionId && this.attributionType) {
        bookingData.attributionId = this.attributionId;
        bookingData.attributionType = this.attributionType;
      }

      return jsSdkBooking.create(bookingData);
    },
    onBookingCreated: function(booking, options) {
      if (!booking) return;

      options = options || {};

      const uiRouterOptions = (options.replaceState) ? {
        location: 'replace'
      } : {};

      $timeout(function() {
        $state.go('app.checkout', {
          bookingId: booking.id,
          iframe: options.iframe,
          theme: options.theme
        }, uiRouterOptions);
      });
    },
    filterVenues: function(venues) {
      const _this = this;

      venues = _.filter(venues, function(venue) {
        return _.includes(_this.venues, venue.id);
      });
      return venues;
    },
    filterCities: function(cities) {
      const _this = this;

      if (_this.cities) {
        cities = _.filter(cities, function(city) {
          return _.includes(_this.cities, city.slugName);
        });
      }

      return cities;
    },
    filterByAllowedItemTypes: function(itemTypes) {
      const _this = this;

      if (_this.itemType) {
        const lockTo = _this.itemType;

        itemTypes = _.filter(itemTypes, function(itemType) {
          return itemType.name === lockTo;
        });
      }

      return itemTypes;
    },
    getTags: function() {
      const _this = this;

      return _this.tags && _this.tags.length ? _this.tags : [];
    },
    getItemType: function() {
      const _this = this;

      return _this.itemType ? _this.itemType : 'Venues';
    },
    widgetSettings: {
      lockTo: null
    }
  };

  const www = createPartnerConfig({
    slug: 'www',
    name: 'Tablelist',
    logo: 'https://assets.tablelist.com/www-2/tablelist/tablelist_logo_white_new_v2.png',
    hideHeader: false,
    hideFooter: false,
    default: true
  });

  const checkout = createPartnerConfig({
    slug: 'checkout',
    name: 'Tablelist Checkout',
    hideHeader: true
  });

  const venue = createPartnerConfig({
    slug: 'venue',
    name: 'Tablelist Venue',
    hideHeader: true,
    hideFooter: true,
    widgetSettings: {
      lockTo: 'venue'
    }
  });

  const widget = createPartnerConfig({
    slug: 'widget',
    name: 'Tablelist Widget',
    hideHeader: true,
    hideFooter: true,
    widgetSettings: {
      lockTo: 'venue'
    },
    onBookingCreated: function(booking) {
      if (!booking) return;

      const queryParams = {};

      // Ensure that subclient (?src=) is passed to checkout
      if ($location.search() && $location.search().src) {
        queryParams.src = $location.search().src;
      }

      const prospectToken = jsSdkKeychain.getProspectToken();

      if (prospectToken) {
        queryParams.prospect = prospectToken;
      }

      // Ensure that affiliateId is passed to checkout.
      if ($rootScope.affiliateId) {
        queryParams.affiliateId = $rootScope.affiliateId;
      }

      // Ensure that attributionId is passed to checkout.
      if (jsSdkConfig.attributionId) {
        queryParams.attributionId = jsSdkConfig.attributionId;
      }

      // Ensure that attributionType is passed to checkout.
      if (jsSdkConfig.attributionType) {
        queryParams.attributionType = jsSdkConfig.attributionType;
      }

      const targetURL = `${config.DOMAIN}/checkout/${booking.id}`;

      const params = {
        eventType: 'checkoutRedirect',
        url: urlService.addQueryParams(targetURL, queryParams)
      };

      iframeService.postMessage(params);

      // Fallback incase the posted message does nothing
      $timeout(function() {
        defaultPartnerConfig.onBookingCreated(booking);
      }, 300);
    }
  });

  const halloween = createPartnerConfig({
    slug: 'halloween',
    name: `Halloween ${CURRENT_YEAR}`,
    path: '/halloween'
  });

  const nye = createPartnerConfig({
    slug: 'nye',
    name: `New Years ${CURRENT_YEAR}`,
    path: '/newyears'
  });

  const newyears = createPartnerConfig({
    slug: 'newyears',
    name: `New Years ${CURRENT_YEAR}`,
    path: '/newyears'
  });

  const rockwellmmwchuckie = createPartnerConfig({
    slug: 'rockwellmmwchuckie',
    name: 'Rockwell MMW Chuckie',
    logo: 'https://assets.tablelist.com/www/assets/tablelist_logo_new.png',
    path: '/e/chuckie-exclusive-hip-hop-set-benefitting-fuck-cancer-at-rockwell-miami-aba689d7b654aaf5',
    attributionId: '39cb704404bfb421',
    attributionType: 'MEMBER'
  });

  const rockwellmmwtorylanez = createPartnerConfig({
    slug: 'rockwellmmwtorylanez',
    name: 'Rockwell MMW Tory Lanel',
    logo: 'https://assets.tablelist.com/www/assets/tablelist_logo_new.png',
    path: '/e/tory-lanez-album-release-party-at-rockwell-64a4341f480cee61',
    attributionId: '39cb704404bfb421',
    attributionType: 'MEMBER'
  });

  const rockwellmmwirie = createPartnerConfig({
    slug: 'rockwellmmwirie',
    name: 'Rockwell MMW Irie',
    logo: 'https://assets.tablelist.com/www/assets/tablelist_logo_new.png',
    path: '/e/irie-miami-music-week-at-rockwell-dc3d0227b9bb6f9a',
    attributionId: '39cb704404bfb421',
    attributionType: 'MEMBER'
  });

  const superbowlAtFilifera = createPartnerConfig({
    slug: 'super-bowl-lii-at-filifera',
    name: 'Super Bowl LII at Filifera',
    logo: 'https://assets.tablelist.com/www/assets/tablelist_logo_new.png',
    path: '/e/super-bowl-lii-at-filifera-f38025d54fd045c9',
    attributionId: '3ecbe3e1d32b0b38',
    attributionType: 'MEMBER'
  });

  const redfez = createPartnerConfig({
    slug: 'redfez',
    name: 'Red Fez',
    path: '/e/red-fez-3-the-final-edition-at-living-room-at-the-w-austin-d1763f60df717ff6',
    attributionId: '0251887142817af4',
    attributionType: 'MEMBER'
  });

  const yelp = createPartnerConfig({
    slug: 'yelp',
    name: 'Yelp',
    hideHeader: true,
    hideFooter: true,
    doNotVerifyInfo: true,
    hideBookingBgImages: true,
    widgetSettings: {
      lockTo: 'venue'
    },
    configure: function() {

      const _this = this;

      _this.opportunityToken = query.get('opportunity_token') || storage.get('opportunity_token');

      // targetOrigin is used to support our Yelp customers.
      _this.targetOrigin = _this.getTargetOrigin();

      query.set('opportunity_token', _this.opportunityToken);
      storage.set('opportunity_token', _this.opportunityToken);

      return defaultPartnerConfig.configure.call(_this);
    },
    createBooking: function(bookingData) {
      const _this = this;

      if (!_this.opportunityToken) {
        _this.opportunityToken = query.get('opportunity_token');
      }

      bookingData = bookingData || {};
      bookingData.status = null; // don't send a status so the API will try and complete
      bookingData.partner = {
        type: _this.name,
        data: {
          opportunityToken: _this.opportunityToken
        }
      };

      bookingData.client = 'yelp';

      return defaultPartnerConfig.createBooking.call(_this, bookingData);
    },
    onBookingCreated: function(booking) {
      const _this = this;

      if (!booking) return;

      const params = {
        eventType: 'checkoutRedirect',
        orderID: booking.partner.id
      };

      iframeService.postMessage(params, _this.targetOrigin);
    },
    getTargetOrigin: function() {
      const yelpSite = query.get('yelp_site') || 'www';
      const yelpLocale = query.get('yelp_locale') || 'en_US';

      const targetOrigins = [
        //US
        {
          yelp_site: 'www',
          yelp_locale: 'en_US',
          origin: 'https://www.yelp.com'
        }, {
          yelp_site: 'm',
          yelp_locale: 'en_US',
          origin: 'https://m.yelp.com'
        },
        //UK
        {
          yelp_site: 'www',
          yelp_locale: 'en_GB',
          origin: 'https://www.yelp.co.uk'
        }, {
          yelp_site: 'm',
          yelp_locale: 'en_GB',
          origin: 'https://m.yelp.co.uk'
        },
        //FR
        {
          yelp_site: 'www',
          yelp_locale: 'fr_FR',
          origin: 'https://www.yelp.fr'
        }, {
          yelp_site: 'm',
          yelp_locale: 'fr_FR',
          origin: 'https://m.yelp.fr'
        },
        //CA
        {
          yelp_site: 'www',
          yelp_locale: 'fr_CA',
          origin: 'https://fr.yelp.ca'
        }, {
          yelp_site: 'm',
          yelp_locale: 'fr_CA',
          origin: 'https://fr.m.yelp.ca'
        },
        //CH
        {
          yelp_site: 'www',
          yelp_locale: 'ch_CH',
          origin: 'https://it.yelp.ch'
        }, {
          yelp_site: 'm',
          yelp_locale: 'ch_CH',
          origin: 'https://m.yelp.ch'
        }, {
          yelp_site: 'm',
          yelp_locale: 'it_CH',
          origin: 'https://it.m.yelp.ch'
        }, {
          yelp_site: 'w',
          yelp_locale: 'ch_CH',
          origin: 'https://www.yelp.ch'
        }
      ];

      const targetOrigin = _.find(targetOrigins, {
        yelp_site: yelpSite,
        yelp_locale: yelpLocale
      });

      return targetOrigin ? targetOrigin.origin : null;
    }
  });

  return {
    www,
    local: www,
    checkout,
    venue,
    widget,

    // Event Series
    halloween,
    nye,
    newyears,

    // Other
    rockwellmmwchuckie,
    rockwellmmwtorylanez,
    rockwellmmwirie,
    superbowlAtFilifera,
    redfez,

    // Booking Services
    yelp: yelp,

    // Aliases
    'yelp-dev': yelp,
    eventWidget: widget,
    venueWidget: widget
  };
}



// WEBPACK FOOTER //
// ./src/services/partnerConfigsService.js